import React from 'react';
import cx from 'classnames';

export default function IconAddUser({
  className,
  onClick,
}: {
  className?: string;
  onClick?: (e: React.MouseEvent) => void;
}) {
  return (
    <svg
      className={cx(className, 'icon icon-addUser')}
      onClick={onClick}
      xmlns="http://www.w3.org/2000/svg"
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="#6C757D"
    >
      <path d="M22.6667 26.6668V27.6668H23.6667V26.6668H22.6667ZM8 26.6668H7V27.6668H8V26.6668ZM19 10.0002C19 12.0252 17.3584 13.6668 15.3333 13.6668V15.6668C18.4629 15.6668 21 13.1298 21 10.0002H19ZM15.3333 13.6668C13.3083 13.6668 11.6667 12.0252 11.6667 10.0002H9.66667C9.66667 13.1298 12.2037 15.6668 15.3333 15.6668V13.6668ZM11.6667 10.0002C11.6667 7.97512 13.3083 6.3335 15.3333 6.3335V4.3335C12.2037 4.3335 9.66667 6.87055 9.66667 10.0002H11.6667ZM15.3333 6.3335C17.3584 6.3335 19 7.97512 19 10.0002H21C21 6.87055 18.4629 4.3335 15.3333 4.3335V6.3335ZM24 12.0002V15.6668H26V12.0002H24ZM24 15.6668V19.3335H26V15.6668H24ZM28.6667 14.6668H25V16.6668H28.6667V14.6668ZM25 14.6668H21.3333V16.6668H25V14.6668ZM12 19.6668H18.6667V17.6668H12V19.6668ZM21.6667 22.6668V26.6668H23.6667V22.6668H21.6667ZM22.6667 25.6668H8V27.6668H22.6667V25.6668ZM9 26.6668V22.6668H7V26.6668H9ZM18.6667 19.6668C20.3235 19.6668 21.6667 21.01 21.6667 22.6668H23.6667C23.6667 19.9054 21.4281 17.6668 18.6667 17.6668V19.6668ZM12 17.6668C9.23858 17.6668 7 19.9054 7 22.6668H9C9 21.01 10.3431 19.6668 12 19.6668V17.6668Z" />
    </svg>
  );
}
